import { AutoPayScheduleReviewScreen } from '@/src/experiences/card-payments/screens/AutoPayScheduleReview'

export default AutoPayScheduleReviewScreen.Screen
